/**
 * EveryINC - Roles Module
 * Role-based access control utilities
 */

import type { UserRole } from './types';

const ROLE_LABELS: Record<UserRole, string> = {
  owner: 'Owner',
  developer: 'Desenvolvedor',
  user: 'Usuario'
};

function getRoleLabel(role: UserRole | string | undefined | null): string {
  if (!role) return 'Usuario';
  return ROLE_LABELS[role as UserRole] || role || 'Usuario';
}

function isOwnerRole(role: UserRole | string | undefined | null): boolean {
  return role === 'owner';
}

function canAccessManagement(role: UserRole | string | undefined | null): boolean {
  return role === 'owner';
}

function canAccessUserManagement(role: UserRole | string | undefined | null): boolean {
  return role === 'owner';
}

function canAccessTrello(role: UserRole | string | undefined | null): boolean {
  return role === 'owner';
}

function canAccessDashboard(role: UserRole | string | undefined | null): boolean {
  return role === 'owner';
}

function canAccessGovernance(role: UserRole | string | undefined | null): boolean {
  return role === 'owner';
}

function requiresAuthToken(role: UserRole | string | undefined | null): boolean {
  return role === 'owner' || role === 'developer';
}

const EveryIncRoles = {
  ROLE_LABELS,
  getRoleLabel,
  isOwnerRole,
  canAccessManagement,
  canAccessUserManagement,
  canAccessTrello,
  canAccessDashboard,
  canAccessGovernance,
  requiresAuthToken
};

// Attach to window for IIFE compatibility
(window as Window).EveryIncRoles = EveryIncRoles;

export {
  ROLE_LABELS,
  getRoleLabel,
  isOwnerRole,
  canAccessManagement,
  canAccessUserManagement,
  canAccessTrello,
  canAccessDashboard,
  canAccessGovernance,
  requiresAuthToken
};

export default EveryIncRoles;
